import React, {createContext, useState} from 'react';
export const PegAmountContext = createContext({});

export const PegAmountProvider = ({children}) => {

    const [pegDetails, setPegDetails] = useState([]);
    return (
        <PegAmountContext.Provider
            value={{
                pegDetails,
                setPegDetails,
            }}>
            {children}
        </PegAmountContext.Provider>
    );
};
